
import React, { useState } from 'react';
import { useSelector} from 'react-redux'
import './carddaydisplay.css'


import {convertMetrics,metricSpeed} from '../../helperFunctions/measurementSystem'


import {GeneralSpeedCalculate} from './../../helperFunctions/TrainingSpeeds'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


import 'rc-slider/assets/index.css';



const DisplayDayModal = (props) => {
  const {
    buttonLabel,
    className
  } = props;


  //const dispatch = useDispatch()


  

  

  //console.log(state)
  const [modal, setModal] = useState(false);
  

 
  const toggle = () => setModal(!modal);
  
  var user = useSelector(state => state.auth)

  const additionalData = () =>{
    if (props.data.subType){
      if  (props.data.subType.includes("Interval")){
        console.log(props.data)
        
          return `Run ${props.data.addData[0]} minutes (high intensity), ${props.data.addData[1]} minutes (low Intensity). Repeat ${(props.data.addData.length/2).toFixed(0)} times`
        
        
       
      }
    }
  }
  const reserve = (heartRate) =>{
    var res = (heartRate - user.rest_hr)/(user.max_hr-user.rest_hr)
    res = parseInt(res*100)
    return res
  }
  
  const colorText = () => {
    
    if (Number(reserve(heartRate(props.data.hrPerc))) > 90){
      return 'text-danger'
    }
    if (Number(reserve(heartRate(props.data.hrPerc))) > 80){
      return 'text-warning'
    }
    if (Number(reserve(heartRate(props.data.hrPerc))) > 70){
      return 'text-success'
    }
    if (Number(reserve(heartRate(props.data.hrPerc))) > 60){
      return 'text-info'
    }
    
    return 'text-white'
    
    
    
    
    
    


  }

  const heartRate = (hrDay) =>{
    return parseInt(user.max_hr*hrDay/100)
  } 
   
  var trimpTss = (activity) => {
    var rest_hr = user.rest_hr
    var max_hr = user.max_hr
    var lactate_th = user.lactate_th
    if (activity.type === "Swim"){
      lactate_th = user.lactate_swim
    }
    if (activity.type === "Ride"){
      lactate_th = user.lactate_cycle
    }
    
    //calculate trimp and tss
    var hrr = (activity.hr-rest_hr)/(max_hr-rest_hr)
    var trimp=0
    Math.round(activity.duration)
    for (var i=0;i<activity.duration;i++){
        trimp = trimp + 1 * hrr * 0.64 * Math.exp(1.92 * hrr)
    }
    
    var hr_lthr = (lactate_th - rest_hr)/(max_hr - rest_hr)
    var hour_lthr = 60 * hr_lthr * 0.64 * Math.exp(1.92 * hr_lthr)
    var tss =  (trimp/hour_lthr)*100
    
    return [tss.toFixed(2),trimp]
  }
  
  if (props.data.subType){
    if(props.data.subType.includes("Interval")){
      if (props.data.subType.includes("1-2")){
        var intervalDuration = (props.data.dur/3).toFixed(0)
        var recoveryDuration = (props.data.dur-intervalDuration).toFixed(0)
        var percentage = (props.data.hrPerc+2*props.data.hrPerLow)/3
      }
      if (props.data.subType.includes("1-3")){
        intervalDuration = (props.data.dur/4).toFixed(0)
        recoveryDuration = (props.data.dur-intervalDuration).toFixed(0)
        percentage = (props.data.hrPerc+3*props.data.hrPerLow)/4
      }
      if (props.data.subType.includes("2-1")){
        intervalDuration = (2*props.data.dur/3).toFixed(0)
        recoveryDuration = (props.data.dur/3).toFixed(0)
        percentage = (2*props.data.hrPerc+props.data.hrPerLow)/3
      }
      if (props.data.subType.includes("3-1")){
        intervalDuration = (3*props.data.dur/4).toFixed(0)
        recoveryDuration = (props.data.dur/4).toFixed(0)
        percentage = (3*props.data.hrPerc+1*props.data.hrPerLow)/4
      }
      if (props.data.subType.includes("1-1")){
        intervalDuration = (props.data.dur/2).toFixed(0)
        recoveryDuration = (props.data.dur/2).toFixed(0)
        percentage = (props.data.hrPerc+props.data.hrPerLow)/2
      }
      var intervalSpeed = GeneralSpeedCalculate(intervalDuration,props.data.hrPerc,user)
      var recoverySpeed = GeneralSpeedCalculate(recoveryDuration,props.data.hrPerLow,user)
      var intervalDistance = ((intervalDuration * Number(intervalSpeed))*1000/60000)
      var recoveryDistance = ((recoveryDuration * Number(recoverySpeed))*1000/60000)
      //console.log(intervalSpeed,recoverySpeed,intervalDistance,recoveryDistance)
      
      
      
      var [tssInt,trimpInt] = trimpTss({hr:heartRate(percentage),duration:props.data.dur,type:props.data.type})
      var totalDistance = (intervalDistance + recoveryDistance).toFixed(2)
      
    }
    
  }
  
  var estSpeed = GeneralSpeedCalculate(props.data.dur,props.data.hrPerc,user)
  var est_distance = ((props.data.dur * estSpeed)*1000/60000).toFixed(2)
  const [tss,trimp] = trimpTss({hr:heartRate(props.data.hrPerc),duration:props.data.dur,type:props.data.type})

  if (props.data.subType.includes("Interval")){
    props.changeSummary(props.dayNo,[props.data.dur,totalDistance,tssInt])
  }
  else{
    if (props.data.type === "Ride" || props.type === "Swim"){
      props.changeSummary(props.dayNo,[props.data.dur,0,tss])
    }
    if (props.data.type === "Rest"){
      props.changeSummary(props.dayNo,[0,0,0])
    }
    else{
      props.changeSummary(props.dayNo,[props.data.dur,est_distance,tss])
    }
    
  }
  return (
    <div>
      <img onClick={toggle} style={{cursor:'pointer'}} src={props.subType} alt="" ></img>
      <Modal isOpen={modal} toggle={toggle} className={className} style={{backgroundColor:'rgb(40,40,40)'}}>
        <ModalHeader toggle={toggle} style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>{props.day}</ModalHeader>
        <ModalBody style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <div class="form-group">

                <div className="cardDisplay">
              
              
              <h2 className="name text-white">{props.data.subType}</h2>
              
              <div className="title">{props.data.type}</div>
              {props.data.type !== "Rest" ?
              <div className="actions">
              <div className="follow-info">
                <h2><a href="#"><span className="text-success">{props.data.dur ? props.data.dur : ''}</span><small>Duration</small></a></h2>
                {props.data.type === "Run" ? 
                <>
                  {props.data.subType.includes("Interval") ?
                  <>
                  <h2><a href="#"><span className={colorText()} style={{fontSize:'20px'}}>{convertMetrics(intervalSpeed,user.measurementSystem)} </span><small>Est Pace Interval ({metricSpeed(user.measurementSystem)})</small></a></h2>
                  <h2><a href="#"><span className='text-info' style={{fontSize:'20px'}}>{convertMetrics(recoverySpeed,user.measurementSystem)} </span><small>Est Pace Recovery ({metricSpeed(user.measurementSystem)})</small></a></h2>
                  <h2><a href="#"><span className="text-white" style={{fontSize:'20px'}}>{totalDistance}</span><small>Est Distance (km)</small></a></h2>
                  </>
                  :
                  <>
                  <h2><a href="#"><span className={colorText()}>{convertMetrics(estSpeed,user.measurementSystem)} </span><small>Est Pace ({metricSpeed(user.measurementSystem)})</small></a></h2>
                  <h2><a href="#"><span className="text-white">{est_distance} </span><small>Est Distance (km)</small></a></h2>
                  </>
                  }
                  
                </>
                : ""}
                {props.data.subType.includes("Interval") ?
                <h2><a href="#" ><span className={colorText()} style={{fontSize:'20px'}}>{heartRate(props.data.hrPerc)}/ <span className='text-info' style={{fontSize:'20px'}}>{heartRate(props.data.hrPerLow)}</span></span><small>Avg Heart rate</small></a></h2>
                :
                <h2><a href="#" ><span className={colorText()}>{heartRate(props.data.hrPerc)}</span><small>Avg Heart rate</small></a></h2>
                }
              </div>
              <div className="follow-info">
                {props.data.subType.includes("Interval") ?
                  <h2><a href="#"><span className="text-danger">{tssInt}</span><small>Stress Score</small></a></h2>
                  : 
                  <h2><a href="#"><span className="text-danger">{tss}</span><small>Stress Score</small></a></h2>
                }
                {props.data.subType.includes("Interval") ?
                <>
                <h2><a href="#"><span className={colorText()} style={{fontSize:'20px'}}>{props.data.hrPerc}/ <span className='text-info'>{props.data.hrPerLow}</span> </span><small>% of max</small></a></h2>
                <h2><a href="#"><span className={colorText()} style={{fontSize:'20px'}}>{reserve(heartRate(props.data.hrPerc))}/ <span className='text-info'>{reserve(heartRate(props.data.hrPerLow))}</span></span><small>% reserve (karvonen formula)</small></a></h2>
                </>
                :
                <>
                <h2><a href="#"><span className={colorText()} style={{fontSize:'20px'}}>{props.data.hrPerc}<span className='text-info'></span> </span><small>% of max</small></a></h2>
                <h2><a href="#"><span className={colorText()} style={{fontSize:'20px'}}>{reserve(heartRate(props.data.hrPerc))} <span className='text-info'></span></span><small>% reserve (karvonen formula)</small></a></h2>
                </>
              }
              </div>
                <div className="follow-btn">
                  
                </div>
              </div>
              : ""}
              
              <div className="desc">{additionalData()}</div>
            </div>
            

  
        
          </div>
        </ModalBody>
        <ModalFooter style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          
          <Button color="danger" onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default DisplayDayModal;